import { render, staticRenderFns } from "./cancelled-telehealth-visits.vue?vue&type=template&id=535960fd&"
import script from "./cancelled-telehealth-visits.vue?vue&type=script&lang=js&"
export * from "./cancelled-telehealth-visits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cancelled-telehealth-visits.vue"
export default component.exports